import { cloneElement, forwardRef } from "react";
import { VariableSizeList } from "react-window";

const ListboxComponent = forwardRef(function ListboxComponent(props, ref) {
  const { children, ...other } = props;
  const itemData = [];

  children.forEach((item) => {
    itemData.push(item);
  });

  const itemCount = itemData.length;
  const itemSize = () => 36;

  const getChild = (index) => itemData[index];

  return (
    <div ref={ref} {...other}>
      <VariableSizeList
        itemData={itemData}
        height={itemCount >= 8 ? 250 : itemCount * 40}
        width="100%"
        outerElementType="div"
        itemCount={itemCount}
        itemSize={itemSize}
        style={{ padding: 8, boxSizing: "border-box" }}
      >
        {({ index, style }) =>
          cloneElement(getChild(index), {
            style: { ...style, top: style.top + 8 },
          })
        }
      </VariableSizeList>
    </div>
  );
});

export default ListboxComponent;
